import { ShopMovieStatus } from '../enums';

export const ShopMovieStatusOptions = [
  {
    key: 'movies.unknown',
    value: ShopMovieStatus.Unknown,
  },
  {
    key: 'movies.active',
    value: ShopMovieStatus.Active,
  },
  {
    key: 'movies.archived',
    value: ShopMovieStatus.Archived,
  },
];
